module.exports = __webpack_public_path__ + "img/ill2.d50b2c3b.svg";